<script setup lang="ts">
import type { PropsContent } from './types';

defineProps<PropsContent>();
</script>

<template>
	<div
		:class="{
			'top-tabs_content': true,
		}"
		:data-tabs-name="name"
	>
		<slot></slot>
	</div>
</template>

<style>
.top-tabs_content {
	padding: 14px;
	overflow: auto;
	display: none;
}
</style>
